import { Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { EmergencyRoomEditFormikValues } from 'presentation/hospital/layouts/EmergencyRoom/EmergencyRoomDetails/types'
import Button from 'presentation/shared/components/Button'
import { Asterisk } from 'presentation/shared/components/SelectField/styles'
import SupportText from 'presentation/shared/components/SupportText'
import React from 'react'

type SelectUseDefaultDoctorProps = {
  setOpenModal: (value: boolean) => void
}

export function SelectUseDefaultDoctor({
  setOpenModal
}: SelectUseDefaultDoctorProps) {
  const { setFieldValue } = useFormikContext<EmergencyRoomEditFormikValues>()

  const handleUseDefaultDoctor = (value: boolean) => {
    setFieldValue('useDefaultDoctor', value)
    if (value === false) {
      setOpenModal(true)
    }
  }

  return (
    <>
      <Grid container item xs={12} spacing={2}>
        <SupportText color="primary">
          Deseja seguir com o médico padrão? <Asterisk>*</Asterisk>
        </SupportText>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid container item xs={12} md={6} lg={3} xl={2}>
          <Button
            fullWidth
            type="button"
            variant="outlined"
            onClick={() => handleUseDefaultDoctor(false)}
          >
            Não
          </Button>
        </Grid>
        <Grid container item xs={12} md={6} lg={3} xl={2}>
          <Button
            fullWidth
            type="button"
            onClick={() => handleUseDefaultDoctor(true)}
          >
            Sim
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
